export const userPreferences = {
  _defaultPreferences: {
    timeFormat: "12h",
    showSeconds: false,
    fontSize: 18,
    theme: "system",
    uiLanguage: "en",
    panchangaLanguage: "en",
    system: "chandramana",
    name_format: "vernacular",
  },

  init() {
    this._setDefaultPreferences();
    this._loadUserPreferences();

    // suppose there is any update to this store,
    // i dont know how to check if new settings have been added.
    this._watchForChanges();
  },

  _loadUserPreferences() {
    const preferences = JSON.parse(
      localStorage.getItem("preferences") || "null",
    );

    if (preferences) {
      Object.assign(this, preferences);
    }
  },

  _saveUserPreferences() {
    const data = Object.fromEntries(this._keys.map((k) => [k, this[k]]));

    localStorage.setItem("preferences", JSON.stringify(data));
    this.preferencesSaved = true;
    setTimeout(() => {
      this.preferencesSaved = false;
    }, 500);
  },

  _setDefaultPreferences() {
    Object.assign(this, this._defaultPreferences);
    this._keys = Object.keys(this._defaultPreferences);
  },

  _watchForChanges() {
    Alpine.watch(
      () => this.uiLanguage,
      (newLang, oldLang) => {
        if (newLang === oldLang) return;

        if (newLang === "en" || newLang === 'sa') {
          this.name_format = "sanskrit";
        } else {
          this.name_format = "vernacular";
        }

        if (["ta", "ml"].includes(newLang)) {
          this.system = "sauramana";
        } else {
          this.system = "chandramana";
        }

        this._saveUserPreferences();
      },
    );

    Alpine.effect(() => {
      let tmp;
      this._keys.forEach((key) => {
        tmp = this[key];
      });

      this._saveUserPreferences();
    });
  },

  resetToDefaultPreferences(key = null) {
    if (key === null) {
      this._setDefaultPreferences();
      return true;
    } else {
      if (this._defaultPreferences.hasOwnProperty(key)) {
        this[key] = this._defaultPreferences[key];
      } else {
        console.warn("Unknown setting " + key);
      }
    }
  },
};
